<template>
    <div class="newsPage">
        <div class="top">
            <img src="../img/logo.png" alt="">
            <div class="line"></div>
            <img src="../img/min_title.png" alt="" class="imgRight">
        </div>
        <div class="main">
            <div class="title">
                走进ICLEC • 大会议程
            </div>
            <div class="timeCon">
                <!-- <div class="timeItem" :class="{ 'currentTime': currentTime == 'one'}" @click="changeTime('one')">12.08</div> -->
                <div class="timeItem" :class="{ 'currentTime': currentTime == 'two'}" @click="changeTime('two')">12.09</div>
                <div class="timeItem" :class="{ 'currentTime': currentTime == 'three'}" @click="changeTime('three')">12.10</div>
                <div class="timeLine"></div>
            </div>
            <div class="wrap" v-if="$i18n.locale=='cn'">
                <div class="firstDay" v-if="currentTime == 'one'">
                    <img src="../img/task.png" alt="">
                    <div>全天报到</div>
                </div>
                <div v-if="currentTime == 'two'">
                    <div class="workMain">
                        <div class="second">
                            <span class="time" >
                                {{timeLine.two.cn[1].time}}
                            </span>
                            <span>
                                {{timeLine.two.cn[1].title}}
                            </span>
                        </div>
                        <div class="secondRight">
                            <div class="workItemCon">
                                <div v-for="(newsItem, index) in timeLine.two.cn[2].content.first" :key="index" class="workItem">
                                    <span class="itemTopic">{{newsItem.topic}}</span>
                                    <span class="itemTitle" @click="toTopicDetail(newsItem.topic_id, newsItem.topic)">{{newsItem.title}}</span>
                                    <div class="colorLine"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="first">
                        <span class="time">
                            {{timeLine.two.cn[0].time}}
                        </span>
                        <span>
                            {{timeLine.two.cn[0].title}}
                        </span>
                    </div>
                    <div class="end">
                         <span class="time">
                            {{timeLine.two.cn[2].time}}
                        </span>
                        <span>
                            {{timeLine.two.cn[2].title}}
                        </span>
                    </div>
                </div>
                <div class="thirdDay" v-if="currentTime == 'three'">
                    <div class="workMain">
                        <div class="second">
                            <span class="time" >
                                {{timeLine.three.cn[1].time}}
                            </span>
                            <span>
                                {{timeLine.three.cn[1].title}}
                            </span>
                        </div>
                        <div class="secondRight">
                            <div class="workItemCon">
                                <div class="timeCon">
                                    <div class="timeItem" :class="{ 'currentTime': currentDate == 1}" @click="changeDate(1)">08:30-10:00</div>
                                    <div class="timeItem" :class="{ 'currentTime': currentDate == 2}" @click="changeDate(2)">10:30-12:00</div>
                                    <div class="timeItem" :class="{ 'currentTime': currentDate == 3}" @click="changeDate(3)">14:00-15:30</div>
                                    <div class="timeLine "></div>
                                </div>
                                <div v-if="currentDate == 1" class="itemContainer">
                                    <div v-for="(newsItem, index) in timeLine.three.cn[0].content.first" :key="index" class="workItem">
                                        <span class="itemTopic">{{newsItem.topic}}</span>
                                        <span class="itemTitle" @click="toTopicDetail(newsItem.topic_id, newsItem.topic)">{{newsItem.title}}</span>
                                        <div class="colorLine"></div>
                                    </div>
                                </div>
                                <div v-if="currentDate == 2" class="itemContainer secondDayWorkItemCon">
                                    <div v-for="(newsItem, index) in timeLine.three.cn[0].content.second" :key="index" class="workItem">
                                        <span class="itemTopic">{{newsItem.topic}}</span>
                                        <span class="itemTitle" @click="toTopicDetail(newsItem.topic_id, newsItem.topic)">{{newsItem.title}}</span>
                                        <div class="colorLine"></div>
                                    </div>
                                </div>
                                <div v-if="currentDate == 3" class="itemContainer">
                                    <div v-for="(newsItem, index) in timeLine.three.cn[0].content.third" :key="index" class="workItem">
                                        <span class="itemTopic">{{newsItem.topic}}</span>
                                        <span class="itemTitle" @click="toTopicDetail(newsItem.topic_id, newsItem.topic)">{{newsItem.title}}</span>
                                        <div class="colorLine"></div>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                    <div class="first">
                        <span class="time">
                            {{timeLine.three.cn[0].time}}
                        </span>
                        <span>
                            {{timeLine.three.cn[0].title}}
                        </span>
                    </div>
                </div>
                <!-- <div>
                    <div class="workMain">

                    </div>
                    <div class="first">
                        11
                    </div>
                    <div class="end">
                        22
                    </div>
                </div>  -->
                
            </div>
            <div class="wrap enWrap" v-if="$i18n.locale=='en'">
                <div class="firstDay" v-if="currentTime == 'one'">
                    <img src="../img/task.png" alt="">
                    <div>全天报到</div>
                </div>
                <div v-if="currentTime == 'two'">
                    <div class="workMain">
                        <div class="second">
                            <span class="time" >
                                {{timeLine.two.en[1].time}}
                            </span>
                            <span>
                                {{timeLine.two.en[1].title}}
                            </span>
                        </div>
                        <div class="secondRight">
                            <div class="workItemCon">
                                <div v-for="(newsItem, index) in timeLine.two.en[2].content.first" :key="index" class="workItem">
                                    <span class="itemTopic">{{newsItem.topic}}</span>
                                    <span class="itemTitle" @click="toTopicDetail(newsItem.topic_id, newsItem.topic)">{{newsItem.title}}</span>
                                    <div class="colorLine"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="first">
                        <span class="time">
                            {{timeLine.two.en[0].time}}
                        </span>
                        <span>
                            {{timeLine.two.en[0].title}}
                        </span>
                    </div>
                    <div class="end">
                         <span class="time">
                            {{timeLine.two.en[2].time}}
                        </span>
                        <span>
                            {{timeLine.two.en[2].title}}
                        </span>
                    </div>
                </div>
                <div class="thirdDay" v-if="currentTime == 'three'">
                    <div class="workMain">
                        <div class="second">
                            <span class="time" >
                                {{timeLine.three.en[1].time}}
                            </span>
                            <span>
                                {{timeLine.three.en[1].title}}
                            </span>
                        </div>
                        <div class="secondRight">
                            <div class="workItemCon">
                                <div class="timeCon">
                                    <div class="timeItem" :class="{ 'currentTime': currentDate == 1}" @click="changeDate(1)">08:30-10:00</div>
                                    <div class="timeItem" :class="{ 'currentTime': currentDate == 2}" @click="changeDate(2)">10:30-12:00</div>
                                    <div class="timeItem" :class="{ 'currentTime': currentDate == 3}" @click="changeDate(3)">14:00-15:30</div>
                                    <div class="timeLine "></div>
                                </div>
                                <div v-if="currentDate == 1" class="itemContainer">
                                    <div v-for="(newsItem, index) in timeLine.three.en[0].content.first" :key="index" class="workItem">
                                        <span class="itemTopic">{{newsItem.topic}}</span>
                                        <span class="itemTitle" @click="toTopicDetail(newsItem.topic_id, newsItem.topic)">{{newsItem.title}}</span>
                                        <div class="colorLine"></div>
                                    </div>
                                </div>
                                <div v-if="currentDate == 2" class="itemContainer secondDayWorkItemCon">
                                    <div v-for="(newsItem, index) in timeLine.three.en[0].content.second" :key="index" class="workItem">
                                        <span class="itemTopic">{{newsItem.topic}}</span>
                                        <span class="itemTitle" @click="toTopicDetail(newsItem.topic_id, newsItem.topic)">{{newsItem.title}}</span>
                                        <div class="colorLine"></div>
                                    </div>
                                </div>
                                <div v-if="currentDate == 3" class="itemContainer">
                                    <div v-for="(newsItem, index) in timeLine.three.en[0].content.third" :key="index" class="workItem">
                                        <span class="itemTopic">{{newsItem.topic}}</span>
                                        <span class="itemTitle" @click="toTopicDetail(newsItem.topic_id, newsItem.topic)">{{newsItem.title}}</span>
                                        <div class="colorLine"></div>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
                    </div>
                    <div class="first">
                        <span class="time">
                            {{timeLine.three.en[0].time}}
                        </span>
                        <span>
                            {{timeLine.three.en[0].title}}
                        </span>
                    </div>
                </div>
                <!-- <div>
                    <div class="workMain">

                    </div>
                    <div class="first">
                        11
                    </div>
                    <div class="end">
                        22
                    </div>
                </div>  -->
                
            </div>
            
        </div>
        
    </div>
</template>

<script>
export default {
  name: 'timeline',
  data: function (){
      return {
          timeLine: {
                one: {
                    cn: [{
                        time: "09:00 - 10:00",
                        title: "全天报到"
                    }],
                    en: [{
                        time: "09:00 - 10:00",
                        title: "Registration"
                    }]
                },
                two: {
                    cn: [
                    {
                        time: "上午",
                        title: "报到"
                    },{
                        time: "15:30-16:40",
                        title: "大会开幕式"
                    },{
                        time: "17:00-18:30",
                        title: "论坛·工作坊",
                        content: {
                            first: [{
                                time: "16:00-17:30",
                                topic: "论坛一：国际中文教育政策",
                                title: "1.1国际中文教育的机遇与挑战",
                                topic_id: 15
                            },{
                                time: "16:00-17:30",
                                topic: "论坛二：孔子学院创新发展",
                                title: "2.1孔子学院公共形象塑造",
                                topic_id: 16
                            },{
                                time: "16:00-17:30",
                                topic: "论坛三：中文教育师资建设",
                                title: "3.1基于需求的“汉语国际教育”专业建设",
                                topic_id: 17
                            },{
                                time: "16:00-17:30",
                                topic: "论坛四：中文教学资源建设",
                                title: "4.1孔子学院课程体系建设",
                                topic_id: 18
                            },{
                                time: "16:00-17:30",
                                topic: "论坛五：国际中文教育服务社会需求",
                                title: "5.1中文教育与复合型人才培养",
                                topic_id: 19
                            },{
                                time: "16:00-17:30",
                                topic: "论坛六：中文教学标准与考试",
                                title: "6.1各国中文教学标准与应用",
                                topic_id: 20
                            },{
                                time: "16:00-17:30",
                                topic: "论坛七：中文教育品牌建设",
                                title: "7.1“汉语桥”项目的优化发展",
                                topic_id: 21
                            },{
                                time: "16:00-17:30",
                                topic: "论坛八：中文教育组织的发展与合作",
                                title: "8.1各国中文教育组织的现状与发展",
                                topic_id: 22
                            }]
                        }
                    }],
                    en: [{
                        time: "Morning",
                        title: "Registration"
                    },{
                        time: "15:30-16:40",
                        title: "Opening Ceremony"
                    },{
                        time: "17:00-18:30",
                        title: "Forums & Workshops",
                        content: {
                            first: [{
                                time: "16:00-17:30",
                                topic: "Forum One: Policies of International Chinese Education",
                                title: "1.1 Opportunities and Challenges for International Chinese Language Education",
                                topic_id: 15
                            },{
                                time: "16:00-17:30",
                                topic: "Forum Two: Innovative Development of Confucius Institutes",
                                title: "2.1 Image Building of Confucius Institutes",
                                topic_id: 16
                            },{
                                time: "16:00-17:30",
                                topic: "Forum Three: Chinese Language Teachers",
                                title: "3.1 The Demand-Based Development of TCSOL Major",
                                topic_id: 17
                            },{
                                time: "16:00-17:30",
                                topic: "Forum Four: Chinese Language Education Resources",
                                title: "4.1 Curriculum Development of Confucius Institutes",
                                topic_id: 18
                            },{
                                time: "16:00-17:30",
                                topic: "Forum Five: Demand-Oriented International Chinese Language Education",
                                title: "5.1 Chinese Language Education and Inter-disciplinary Talents",
                                topic_id: 19
                            },{
                                time: "16:00-17:30",
                                topic: "Forum Six: Chinese Language Education Standards and Tests",
                                title: "6.1 Chinese Language Education Standards and Applications in Different Countries",
                                topic_id: 20
                            },{
                                time: "16:00-17:30",
                                topic: "Forum Seven: Brand Programs of Chinese Language Education",
                                title: '7.1 Advancement of "Chinese Bridge" Programs',
                                topic_id: 21
                            },{
                                time: "16:00-17:30",
                                topic: "Forum Eight: Cooperation Between Chinese Language Education Organizations",
                                title: "8.1 Current Situation and Development of Chinese Language Education Organizations in Different Countries",
                                topic_id: 22
                            }]
                        }
                    }]
                },
            three: {
                cn: [{
                        time: "08:30-15:30",
                        title: "论坛·工作坊",
                        content: {
                            first: [{
                                time: "08:30-10:00",
                                topic: "论坛一：国际中文教育政策",
                                title: "1.2各国中文教育的政策和实践",
                                topic_id: 23
                            },{
                                time: "08:30-10:00",
                                topic: "论坛二：孔子学院创新发展",
                                title: "2.2中外大学发挥孔子学院办学主体作用",
                                topic_id: 24
                            },{
                                time: "08:30-10:00",
                                topic: "论坛三：中文教育师资建设",
                                title: "3.2国际中文教师标准与能力认证",
                                topic_id: 25
                            },{
                                time: "08:30-10:00",
                                topic: "论坛四：中文教学资源建设",
                                title: "4.2国际中文教育资源共建共享",
                                topic_id: 26
                            },{
                                time: "08:30-10:00",
                                topic: "论坛五：国际中文教育服务社会需求",
                                title: "5.2中文教育与学生创业就业",
                                topic_id: 27
                            },{
                                time: "08:30-10:00",
                                topic: "论坛六：中文教学标准与考试",
                                title: "6.2中外合作开发中文教学新标准",
                                topic_id: 28
                            },{
                                time: "08:30-10:00",
                                topic: "论坛七：中文教育品牌建设",
                                title: "7.2“新汉学”计划的拓展与提升",
                                topic_id: 29
                            },{
                                time: "08:30-10:00",
                                topic: "论坛八：中文教育组织的发展与合作",
                                title: "8.2国际中文教育的多边合作",
                                topic_id: 30
                            }],
                            second: [{
                                time: "10:30-12:00",
                                topic: '专题论坛',
                                title: '"中文+职业技能"项目',
                                mainTitle: "论坛",
                                topic_id: 47
                            },{
                                time: "10:30-12:00",
                                topic: "论坛一：国际中文教育政策",
                                title: "1.3中文教育发展与高校国际化",
                                mainTitle: "工作坊",
                                topic_id: 31
                            },{
                                time: "10:30-12:00",
                                topic: "论坛二：孔子学院创新发展",
                                title: "2.3孔子学院的特色化发展与区域协作",
                                topic_id: 32
                            },{
                                time: "10:30-12:00",
                                topic: "论坛三：中文教育师资建设",
                                title: "3.3中文教师本土化的新思路",
                                topic_id: 33
                            },{
                                time: "10:30-12:00",
                                topic: "论坛四：中文教学资源建设",
                                title: "4.3智能时代的国际中文教学创新案例",
                                topic_id: 34
                            },{
                                time: "10:30-12:00",
                                topic: "论坛五：国际中文教育服务社会需求",
                                title: "5.3中文教育与中外经贸合作",
                                topic_id: 35
                            },{
                                time: "10:30-12:00",
                                topic: "论坛六：中文教学标准与考试",
                                title: "6.3专门用途的中文教学标准与考试",
                                topic_id: 36
                            },{
                                time: "10:30-12:00",
                                topic: "论坛七：中文教育品牌建设",
                                title: "7.3各国中文教育品牌项目分享",
                                topic_id: 37
                            },{
                                time: "10:30-12:00",
                                topic: "论坛八：中文教育组织的发展与合作",
                                title: "8.3中文教育组织与孔子学院发展",
                                topic_id: 38
                            }],
                            third: [{
                                time: "14:00-15:30",
                                topic: "论坛一：国际中文教育政策",
                                title: "1.4中外合作开展中文教育的新途径",
                                topic_id: 39
                            },{
                                time: "14:00-15:30",
                                topic: "论坛二：孔子学院创新发展",
                                title: "2.4孔子学院办学质量评估",
                                topic_id: 40
                            },{
                                time: "14:00-15:30",
                                topic: "论坛三：中文教育师资建设",
                                title: "3.4汉语教师志愿者项目的瓶颈与发展",
                                topic_id: 41
                            },{
                                time: "14:00-15:30",
                                topic: "论坛四：中文教学资源建设",
                                title: "4.4国际中文教材的本地化",
                                topic_id: 42
                            },{
                                time: "14:00-15:30",
                                topic: "论坛五：国际中文教育服务社会需求",
                                title: "5.4中文教育与文化多元发展",
                                topic_id: 43
                            },{
                                time: "14:00-15:30",
                                topic: "论坛六：中文教学标准与考试",
                                title: "6.4汉语水平考试（HSK）改进与推广",
                                topic_id: 44
                            },{
                                time: "14:00-15:30",
                                topic: "论坛七：中文教育品牌建设",
                                title: "7.4 中外双向文化交流",
                                topic_id: 45
                            },{
                                time: "14:00-15:30",
                                topic: "论坛八：中文教育组织的发展与合作",
                                title: "8.4 各国中文专业（项目）负责人联席会",
                                topic_id: 46
                            }],
                        }
                    },{
                        time: "16:00-17:20",
                        title: "闭幕式"
                    }],
                    en: [{
                        time: "08:30-15:30",
                        title: "Forums & Workshops",
                        content: {
                            first: [{
                                time: "08:30-10:00",
                                topic: "Forum One: Policies of International Chinese Education",
                                title: "1.2 Policies and Practices of Chinese Language Education in Different Countries",
                                topic_id: 23
                            },{
                                time: "08:30-10:00",
                                topic: "Forum Two: Innovative Development of Confucius Institutes",
                                title: "2.2 Highlighting the Role of Chinese and Host Institutions in Confucius Institutes Operation",
                                topic_id: 24
                            },{
                                time: "08:30-10:00",
                                topic: "Forum Three: Chinese Language Teachers",
                                title: "3.2 Standards and Certification for International Chinese Language Teachers",
                                topic_id: 25
                            },{
                                time: "08:30-10:00",
                                topic: "Forum Four: Chinese Language Education Resources",
                                title: "4.2 Co-developing and Sharing of International Chinese Language Education Resources",
                                topic_id: 26
                            },{
                                time: "08:30-10:00",
                                topic: "Forum Five: Demand-Oriented International Chinese Language Education",
                                title: "5.2 Chinese Language Education and Career Development of Students",
                                topic_id: 27
                            },{
                                time: "08:30-10:00",
                                topic: "Forum Six: Chinese Language Education Standards and Tests",
                                title: "6.2 Co-development of Chinese Language Education Standards",
                                topic_id: 28
                            },{
                                time: "08:30-10:00",
                                topic: "Forum Seven: Brand Programs of Chinese Language Education",
                                title: '7.2 Improvement of "Confucius China Studies Program"',
                                topic_id: 29
                            },{
                                time: "08:30-10:00",
                                topic: "Forum Eight: Cooperation Between Chinese Language Education Organizations",
                                title: "8.2 Multilateral Cooperation in International Chinese Language Education",
                                topic_id: 30
                            }],
                            second: [{
                                time: "10:30-12:00",
                                topic: "Projects Forum:",
                                title: "Chinese Language + Vocational Skills",
                                mainTitle: 'Forum',
                                topic_id: 47
                            },{
                                time: "10:30-12:00",
                                topic: "Forum One: Policies of International Chinese Education",
                                title: "1.3 Development of Chinese Language Education and Internationalization of Higher Education Institutions",
                                mainTitle: 'WorkShops',
                                topic_id: 31
                            },{
                                time: "10:30-12:00",
                                topic: "Forum Two: Innovative Development of Confucius Institutes",
                                title: "2.3 Featured Development and Regional Cooperation of Confucius Institutes",
                                topic_id: 32
                            },{
                                time: "10:30-12:00",
                                topic: "Forum Three: Chinese Language Teachers",
                                title: "3.3 New Approaches for the Localization of Chinese Language Teachers",
                                topic_id: 33
                            },{
                                time: "10:30-12:00",
                                topic: "Forum Four: Chinese Language Education Resources",
                                title: "4.3 Innovative Practices of International Chinese Language Education in the Era of AI",
                                topic_id: 34
                            },{
                                time: "10:30-12:00",
                                topic: "Forum Five: Demand-Oriented International Chinese Language Education",
                                title: "5.3 Chinese Language Education and Business Cooperation",
                                topic_id: 35
                            },{
                                time: "10:30-12:00",
                                topic: "Forum Six: Chinese Language Education Standards and Tests",
                                title: "6.3 Chinese Language Education Standards and Tests for Specific Purposes",
                                topic_id: 36
                            },{
                                time: "10:30-12:00",
                                topic: "Forum Seven: Brand Programs of Chinese Language Education",
                                title: "7.3 Experience Sharing of Chinese Language Education Brand Programs in Different Countries",
                                topic_id: 37
                            },{
                                time: "10:30-12:00",
                                topic: "Forum Eight: Cooperation Between Chinese Language Education Organizations",
                                title: "8.3 Chinese Language Education Organizations and Development of Confucius Institutes",
                                topic_id: 38
                            }],
                            third: [{
                                time: "14:00-15:30",
                                topic: "Forum One: Policies of International Chinese Education",
                                title: "1.4 New Approaches to Cooperation of Chinese Language Education between Chinese and Host Institutions",
                                topic_id: 39
                            },{
                                time: "14:00-15:30",
                                topic: "Forum Two: Innovative Development of Confucius Institutes",
                                title: "2.4 Performance Evaluation of Confucius Institutes",
                                topic_id: 40
                            },{
                                time: "14:00-15:30",
                                topic: "Forum Three: Chinese Language Teachers",
                                title: "3.4 Bottleneck and Breakthrough of Volunteer Chinese Teacher Program",
                                topic_id: 41
                            },{
                                time: "14:00-15:30",
                                topic: "Forum Four: Chinese Language Education Resources",
                                title: "4.4 Localization of International Chinese Textbooks and Learning Materials",
                                topic_id: 42
                            },{
                                time: "14:00-15:30",
                                topic: "Forum Five: Demand-Oriented International Chinese Language Education",
                                title: "5.4 Chinese Language Education and Cultural Diversity",
                                topic_id: 43
                            },{
                                time: "14:00-15:30",
                                topic: "Forum Six: Chinese Language Education Standards and Tests",
                                title: "6.4 Improvement and Promotion of HSK",
                                topic_id: 44
                            },{
                                time: "14:00-15:30",
                                topic: "Forum Seven: Brand Programs of Chinese Language Education",
                                title: "7.4 Two-way Cultural Exchange between China and Other Countries",
                                topic_id: 45
                            },{
                                time: "14:00-15:30",
                                topic: "Forum Eight: Cooperation Between Chinese Language Education Organizations",
                                title: "8.4 Joint Meeting of Heads of Chinese Language Major (Programs) in Different Countries",
                                topic_id: 46
                            }],
                        }
                    },{
                        time: "16:00-17:20",
                        title: "Closing Ceremony"
                    }]
            }

                
          },
          currentTime: "two",
          currentDate: 1
      }
  },
  methods: {
      changeTime (index) {
          this.currentTime = index
      },
      changeDate (index) {
          this.currentDate = index
      },
      toTopicDetail (topicid,title) {
        // this.$router.push({
        //   path: '/pcpage/detailpage/topicdetail',
        //   query: {
        //     topic_id: topicid,
        //     title: title
        //   }
        // })
      }
  },
  mounted () {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div::-webkit-scrollbar{
  width:5px;
  height:10px;
  /**/
}
div::-webkit-scrollbar-track{
  background: rgb(239, 239, 239);
  border-radius:4px;
}
div::-webkit-scrollbar-thumb{
  background: #f3bc65;
  border-radius:10px;
}
div::-webkit-scrollbar-thumb:hover{
  background: #999;
}
div::-webkit-scrollbar-corner{
  background: #179a16;
}
.newsPage {
    .top {
        margin-left: 57px;
        padding-top: 30px;
        .line {
            display: inline-block;
            width: 1px;
            height: 80px;
            background-color: rgba(255,255,255,0.5);
            margin: 0 45px;
            vertical-align: super;
        }
    }
    .main {
        margin-left: 240px;
        //float: right;
        .title {
            font-size: 60px;
            color: #f3bc65;
            font-weight: bold;
            margin: 28px 120px;
        }
        .timeCon {
            margin: 28px 125px;
            .timeItem {
                display: inline-block;
                font-size: 60px;
                font-weight: bold;
                margin-right: 51px;
                padding: 0 10px;
                color: #80e1ff;
                cursor: pointer;
            }
            .currentTime {
                position: relative;
                border-bottom: 5px solid #f3bc65;
                color: #f3bc65;
                z-index: 5;
            }
            .timeLine {
                width: 1190px;
                height: 5px;
                background-image: url(../img/timeline_bg.png);
                transform: translateY(-5px);
            }
        }
        .wrap {
            position: relative;
            margin-left: 120px;
            .firstDay {
                text-align: center;

                img {
                    width: 112px;
                    margin-top: 140px;
                    margin-bottom: 31px;
                }
                div {
                    font-size: 30px;
                    color: #80e1ff;
                    letter-spacing: 0.2em;
                }
            }
            .workMain {
                position: absolute;
                top: 0;
                left: 0;
                width: 1200px;
                height: 498px;
                background-image: url(../img/opcity_1_bg.png);
                background-size: contain;
                background-repeat: no-repeat;
            }
            .first {
                position: absolute;
                top: 0;
                left: 0;
                width: 300px;
                height: 101px;
            }
            .end {
                position: absolute;
                top: 230px;
                left: 0;
                width: 300px;
                height: 101px;
            }
            .second {
                position: absolute;
                top: 115px;
                left: 0;
            }
            .first,.end,.second {
                .time {
                    display: inline-block;
                    color: #80e1ff;
                    margin: 43px 17px;
                }
                span:nth-child(2) {
                    color: #fff;
                    margin: 43px 5px;
                }
            }
            .first {
                .time {
                    margin: 43px 17px 43px 78px;
                }
            }

            .secondRight {
                width: 888px;
                height: 481px;
                position: absolute;
                top: 0;
                left: 300px;
                .timeCon {
                    margin: 10px 0 0;
                    padding-bottom: 10px;
                    text-align: right;
                    .timeItem {
                        display: inline-block;
                        
                        font-size: 24px;
                        font-weight: bold;
                        margin-right: 51px;
                        padding: 0 10px 6px;
                        color: #80e1ff;
                        cursor: pointer;
                    }
                    .currentTime {
                        position: relative;
                        border-bottom: 3px solid #f3bc65;
                        color: #f3bc65;
                        z-index: 5;
                    }
                    .timeLine {
                        width: 830px;
                        height: 3px;
                        background-image: url(../img/timeline_bg.png);
                        transform: translateY(-4px);
                    }
                }
                .workItemCon {
                    padding: 35px 20px 44px 35px;
                    .workItem {
                        padding:8px 0 10px;
                        font-family: Sans serif;
                        .itemTopic {
                            display: inline-block;
                            width: 290px;
                            font-weight: bold;
                            color: #fff;
                            font-size: 18px;
                        }
                        .itemTitle {
                            display: inline-block;
                            color: #fff;
                            font-size: 18px;
                            margin-left: 57px;
                            cursor: pointer;
                        }
                         .colorLine {
                             margin-top: 10px;
                             width: 100%;
                             height: 1px;
                             background-image: linear-gradient(90deg, 
                                #02baf2 0%, 
                                #009dcd 100%), 
                            linear-gradient(
                                #ffffff, 
                                #ffffff);
                            background-blend-mode: normal, 
                                normal;

                         }
                    }
                }
            }
            .thirdDay {
                .workMain {
                    background-image: url(../img/opcity_bg.png);
                }
                
                .second {
                    .time {
                        margin: 43px 17px 43px 48px;
                    }
                }
                .first {
                    .time {
                        margin: 43px 17px 43px 48px;
                    }
                    
                }
                .workItemCon {
                    padding: 10px 0 44px 35px;
                    .secondDayWorkItemCon {
                        height: 392px;
                        overflow-y: auto;
                        
                        .workItem:first-child {
                            margin-bottom: 35px;
                            // .colorLine {
                            //     height: 0px;
                            // }
                        }
                    }
                }
            }
        }
        .enWrap {
            position: relative;
            margin-left: 120px;
            font-family: sans-serif;
            white-space: initial;
            .firstDay {
                text-align: center;

                img {
                    width: 112px;
                    margin-top: 140px;
                    margin-bottom: 31px;
                }
                div {
                    font-size: 26px;
                    color: #80e1ff;
                    letter-spacing: 0.2em;
                }
            }
            .workMain {
                position: absolute;
                top: 0;
                left: 0;
                width: 1200px;
                height: 498px;
                background-image: url(../img/opcity_1_bg.png);
                background-size: contain;
                background-repeat: no-repeat;
            }
            .first {
                position: absolute;
                top: 0;
                left: 0;
                width: 300px;
                height: 101px;
            }
            .end {
                position: absolute;
                top: 230px;
                left: 0;
                width: 300px;
                height: 101px;
            }
            .second {
                position: absolute;
                top: 115px;
                left: 0;
            }
            .first,.end,.second {
                font-size: 16px;
                .time {
                    display: inline-block;
                    color: #80e1ff;
                    margin: 43px 5px 43px 17px;
                }
                span:nth-child(2) {
                    color: #fff;
                    margin: 43px 5px;
                }
            }
            .first {
                .time {
                    margin: 43px 5px 43px 48px;
                }
            }

            .secondRight {
                width: 878px;
                height: 420px;
                position: absolute;
                top: 6px;
                left: 300px;
                overflow-y: auto;
                .timeCon {
                    margin: 10px 0 0;
                    padding-bottom: 10px;
                    text-align: right;
                    .timeItem {
                        display: inline-block;
                        
                        font-size: 20px;
                        font-weight: bold;
                        margin-right: 51px;
                        padding: 0 10px 6px;
                        color: #80e1ff;
                        cursor: pointer;
                    }
                    .currentTime {
                        position: relative;
                        border-bottom: 3px solid #f3bc65;
                        color: #f3bc65;
                        z-index: 5;
                    }
                    .timeLine {
                        width: 830px;
                        height: 3px;
                        background-image: url(../img/timeline_bg.png);
                        transform: translateY(-4px);
                    }
                }
                .workItemCon {
                    padding: 35px 20px 44px 35px;
                    .workItem {
                        padding:8px 0 10px;
                        .itemTopic {
                            display: inline-block;
                            width: 290px;
                            font-weight: bold;
                            color: #fff;
                            font-size: 16px;
                            vertical-align: top;
                        }
                        .itemTitle {
                            display: inline-block;
                            width: calc(100% - 357px);
                            color: #fff;
                            font-size: 16px;
                            margin-left: 57px;
                            cursor: pointer;
                            vertical-align: top;
                        }
                         .colorLine {
                             margin-top: 10px;
                             width: 100%;
                             height: 1px;
                             background-image: linear-gradient(90deg, 
                                #02baf2 0%, 
                                #009dcd 100%), 
                            linear-gradient(
                                #ffffff, 
                                #ffffff);
                            background-blend-mode: normal, 
                                normal;

                         }
                    }
                }
            }
            
            .thirdDay {
                .workMain {
                    background-image: url(../img/opcity_bg.png);
                }
                
                .second {
                    .time {
                        margin: 43px 10px 43px 18px;
                    }
                }
                .first {
                    .time {
                        margin: 43px 10px 43px 18px;
                    }
                    
                }
                .secondRight {
                    height: 450px;
                    overflow: hidden;
                    .itemContainer {
                        height: 392px;
                        overflow-y: auto;
                    }
                    
                }
                .workItemCon {
                    padding: 10px 0 44px 35px;
                    .secondDayWorkItemCon {
                        
                        .workItem:first-child {
                            margin-bottom: 35px;
                            
                        }
                    }
                    
                }
                
            }
        }
        
    }
    
}
.clearfix:after,.clearfix:before{
        content: "";
        display: table;
    }
    .clearfix:after{
        clear: both;
    }
    .clearfix{
        *zoom: 1;
    }
@media screen and (min-width: 1240px) and (max-width: 1280px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        float: left;
        text-align: left;
        margin-left: 0;
        .title {
            margin: 28px 28px;
            font-size: 36px;
        }
        .timeCon,.wrap {
            margin-left: 15px;
        }
        .timeCon {
            margin-left: 28px;
            .timeItem {
                font-size: 32px;
            }
            .timeLine {
                width: 880px;
            }
        }
        .wrap {
            .secondRight {
                width: 630px;
                height: 312px;
                left: 230px;
                top: 6px;
                overflow-y: auto;
                .timeCon .timeLine {
                    width: 740px;
                }
                .workItemCon {
                    padding: 15px 8px 14px 4px;
                    .workItem {
                    padding: 6px 0 8px;
                    .itemTopic,.itemTitle {
                        font-size: 14px;
                    }
                }
                }
            }
            .thirdDay {
                .workMain {
                    width: 828px;
                    height: 330px;
                    .second {
                        top: 79px;
                        .time {
                            margin: 33px 17px 27px 20px;
                        }
                    }
                }
                .first {
                    .time {
                        margin: 33px 17px 27px 20px;
                    }
                }
                .secondRight {
                    height: 309px;
                    width: 580px;
                    overflow: hidden;
                    .itemContainer {
                        height: 255px;
                        overflow-y: auto;
                        .workItem {
                            .itemTitle {
                                width: calc(100% - 357px);
                                display: inline-block;
                                white-space: initial;
                                line-height: 1.2;
                            }
                            
                            
                        }
                    }
                    .workItemCon {
                        box-sizing: border-box;
                        padding: 0 0 0 0;
                        .secondDayWorkItemCon {
                            
                            
                            .workItem:first-child {
                                margin-bottom: 35px;
                                // .colorLine {
                                //     height: 0px;
                                // }
                            }
                        }
                        
                    }
                }
            }
        }
        .wrap .workMain {
            width: 940px;
            height: 330px;
            .second {
                top: 70px;
                font-size: 12px;
                .time {
                    margin: 43px 5px 43px 10px;
                }
            }
            
        }
        .wrap .first {
            font-size: 12px;
            width: 220px;
            height: 76px;
            .time {
                margin: 33px 17px 23px 37px;
            }
        }
        .wrap .end {
            font-size: 12px;
            width: 230px;
            height: 75px;
            top: 165px;
            .time {
                margin: 33px 4px 23px 10px;
            }
        }
        .enWrap {
            .first {
                .time {
                    margin: 33px 5px 23px 26px;
                }
            }
            .end {
                .time {
                    margin: 33px 5px 23px 10px;
                }
            }
            .thirdDay {
                .workMain {
                    .second {
                        .time {
                            margin: 33px 5px 27px 10px;
                        }
                        
                    }
                    
                }
                .first {
                        .time {
                             margin: 33px 0px 27px 10px;
                        }
                    }
            }
        }
    }
}

  
}
@media screen and (min-width: 1280px) and (max-width: 1600px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        float: left;
        text-align: left;
        margin-left: 0;
        .title {
            margin: 28px 28px;
            font-size: 36px;
        }
        .timeCon,.wrap {
            margin-left: 15px;
        }
        .timeCon {
            margin-left: 28px;
            .timeItem {
                font-size: 36px;
            }
            .timeLine {
                width: 1030px;
            }
        }
        .wrap {
            .secondRight {
                width: 759px;
                height: 385px;
                .timeCon .timeLine {
                    width: 740px;
                }
                .workItemCon {
                    padding: 35px 28px 44px 14px;
                    .workItem {
                    padding: 6px 0 8px;
                    .itemTopic,.itemTitle {
                        font-size: 16px;
                    }
                }
                }
            }
            .end {
                top: 204px;
            }
            .thirdDay {
                .secondRight {
                    height: 410px;
                    overflow: hidden;
                    .itemContainer {
                        height: 350px;
                        overflow-y: auto;
                    }
                    .workItemCon {
                        .secondDayWorkItemCon {
                            height: 351px;
                            overflow-y: auto;
                            
                            .workItem:first-child {
                                margin-bottom: 35px;
                                // .colorLine {
                                //     height: 0px;
                                // }
                            }
                        }
                        padding: 8px 28px 44px 14px;
                    }
                }
            }
        }
        .wrap .workMain {
            max-width: 1030px;
            .second {
                top: 100px;
            }
        }
    }
}

  
}

@media screen and (min-width: 1460px) and (max-width: 1680px) {
.newsPage {
    .main {
        margin-left: 0;
        float: left;
        .title {
            margin: 28px 60px;
        }
        .timeCon,.wrap {
            margin: 28px 60px;
        }
    }
}

  
}
</style>
